import { render } from "./WildBookEntryHunting.vue?vue&type=template&id=dbb57568&scoped=true&ts=true"
import script from "./WildBookEntryHunting.vue?vue&type=script&lang=ts"
export * from "./WildBookEntryHunting.vue?vue&type=script&lang=ts"

import "./WildBookEntryHunting.vue?vue&type=style&index=0&id=dbb57568&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb57568"]])

export default __exports__